import { Injectable } from '@angular/core';
import { appSettings, errorMessages } from "../../settings";
import { CommonService } from "../common.service";
import { WidgethelperService } from "../widgethelper.service";
import { BaseService } from "./base.service";

@Injectable()
export class HourlyordersService  extends BaseService{

  constructor(
    private _commonService: CommonService,
    private _widgetHelper: WidgethelperService
  ) { 
    super();
  }

  init(widget: any) {
    this._widgetHelper.CreateHub(widget)
    this.DisplayData(widget);
  }

  DisplayData(widget: any) {
    widget.hub.listenFor("broadcastHourlyOrders").subscribe(
      (result: any) => {
        // console.log("broadcastHourlyOrders", result);
        let resultwid;
        let resultcreationtime;
        let lastUpdatedTime;

        if (result && result.length > 0) {
          widget.IfNoDataFound = result[0].IsNoDataFound;
          resultwid = result[0].widgetid;
          resultcreationtime = result[0].widgetcreationtime;
          lastUpdatedTime = result[0].LastUpdateTime;
        }
        else {
          widget.errorMessage = errorMessages.noWidgetData;
        }

        if (resultwid == widget.widgetId && resultcreationtime == widget.widgetcreationtime) {
          widget.dataLoaded = false;
          widget.chartOptions = this.customizeChartOptions('',false);
          widget.errorMessage = null;
          if(widget.IfNoDataFound){
            widget.errorMessage = errorMessages.noWidgetData;
          }else if (widget.IfNoDataFound == null) {
            widget.errorMessage = "Retrieving records. Please wait...";
          }
          else{
            let Report_Periods = [];
            let ordersDropped = [];
            let unitsDropped = [];
            let unitsPicked = [];
            let unitsPacked = [];
            let shippedOrdersFedex = [];
            let shippedUnitsFedex = [];
            let shippedOrdersONTG = [];
            let shippedUnitsONTG = [];
            let shippedOrdersNEWG = [];
            let shippedUnitsNEWG = [];
            let totalShippedOrders = [];
            let totalShippedUnits = [];
            
            result.forEach(element => {
              let rptHour = "";
              rptHour = element.REPORT_HOUR;
              if (rptHour != '' && Report_Periods.indexOf(rptHour) == -1) {
                Report_Periods.push(rptHour);
              }
            });

            Report_Periods.forEach(element => {
              result.find(item => {
                if((item.REPORT_HOUR == element)){
                  ordersDropped.push([element, item.ORDERS_DROPPED]);  
                  unitsDropped.push([element, item.UNITS_DROPPED]); 
                  unitsPicked.push([element, item.UNITS_PICKED]);  
                  unitsPacked.push([element, item.UNITS_PACKED]);                  
                  shippedOrdersFedex.push([element, item.SHIPPED_ORDERS_FEDEX]);  
                  shippedUnitsFedex.push([element, item.SHIPPED_UNITS_FEDEX]); 
                  shippedOrdersONTG.push([element, item.SHIPPED_ORDERS_ONTG]);  
                  shippedUnitsONTG.push([element, item.SHIPPED_UNITS_ONTG]);
                  shippedOrdersNEWG.push([element, item.SHIPPED_ORDERS_NEWG]);  
                  shippedUnitsNEWG.push([element, item.SHIPPED_UNITS_NEWG]); 
                  totalShippedOrders.push([element, item.TOTAL_SHIPPED_ORDERS]);  
                  totalShippedUnits.push([element, item.TOTAL_SHIPPED_UNITS]);
                }
              });
            });                  
                        
            this.addDataSeries(widget.chartOptions, ordersDropped, 'Orders Dropped', 'bar'); 
            this.addDataSeries(widget.chartOptions, unitsDropped, 'Units Dropped', 'bar');
            this.addDataSeries(widget.chartOptions, unitsPicked, 'Units Picked', 'bar'); 
            this.addDataSeries(widget.chartOptions, unitsPacked, 'Units Packed', 'bar');
            this.addDataSeries(widget.chartOptions, shippedOrdersFedex, 'Shipped Orders Fedex', 'bar'); 
            this.addDataSeries(widget.chartOptions, shippedUnitsFedex, 'Shipped Units Fedex', 'bar');
            this.addDataSeries(widget.chartOptions, shippedOrdersONTG, 'Shipped Orders ONTG', 'bar'); 
            this.addDataSeries(widget.chartOptions, shippedUnitsONTG, 'Shipped Units ONTG', 'bar');
            this.addDataSeries(widget.chartOptions, shippedOrdersNEWG, 'Shipped Orders NEWG', 'bar'); 
            this.addDataSeries(widget.chartOptions, shippedUnitsNEWG, 'Shipped Units NEWG', 'bar');
            this.addDataSeries(widget.chartOptions, totalShippedOrders, 'Total Shipped Orders', 'bar'); 
            this.addDataSeries(widget.chartOptions, totalShippedUnits, 'Total Shipped Units', 'bar');
            this.addZoomBar(widget.chartOptions);
            //Sorting
            let reportHour = Report_Periods.sort(function (a, b) { return a < b ? -1 : 1; });
            widget.chartOptions.xAxis.data = reportHour;
            widget.chartOptions.tooltip.formatter = this.toolTipNumberFormatter;
            widget.chartOptions.xAxis.axisLabel.rotate = 45;
          }
        }
        // console.log('widget options:',widget.chartOptions);
        widget.dataLoaded = true;
        this._commonService.lastUpdatedTime = lastUpdatedTime;
        
      },
      err => {
        console.log("Listen for broadcastHourlyOrders error:", err);
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/services/widgets/hourlyorders.service.ts